import api from "../../api.js"

// Cart
export const addToCart = (payload) => api.post("/frontshop/checkout/cart/add", payload)
export const getCart = () => api.get("/frontshop/checkout/cart")
export const updateCartItem = (payload) => api.post("/frontshop/checkout/cart/update", payload)
export const clearCart = () => api.post("/frontshop/checkout/cart/clear")

// Customers
export const listCustomers = (params) => api.get("/frontshop/checkout/customers", { params })
export const getCustomerDetails = (patientid) => api.get(`/frontshop/checkout/customer/${patientid}/details`)
export const selectCustomer = (patientid) => api.post("/frontshop/checkout/customer/select", { patientid })
export const getSelectedCustomer = () => api.get("/frontshop/checkout/customer/selected")
export const clearSelectedCustomer = () => api.post("/frontshop/checkout/customer/clear")

// Payment
export const getPaymentOptions = () => api.get("/frontshop/payment/options")
export const setPaymentTotal = () => api.post("/frontshop/payment/total/set")
export const getPaymentTotal = () => api.get("/frontshop/payment/total")
export const previewCash = (tendered) => api.post("/frontshop/payment/cash/preview", { tendered })
export const confirmCash = (tendered) => api.post("/frontshop/payment/cash/confirm", { tendered })
export const confirmNonCash = (optionid) => api.post("/frontshop/payment/noncash/confirm", { optionid })
export const completeCodPayment = (recieptno, method2, tendered) => api.post("/frontshop/payment/cod/complete", { recieptno, method2, tendered })
export const loadUnpaidOrderToCart = (recieptno) => api.post("/frontshop/checkout/cart/load-unpaid", { recieptno })
export const previewCredit = () => api.post("/frontshop/payment/credit/preview")
export const confirmCredit = () => api.post("/frontshop/payment/credit/confirm")

// Split payment
export const startSplitPayment = (amount1, method1) => api.post("/frontshop/payment/split/start", { amount1, method1 })
export const getSplitState = () => api.get("/frontshop/payment/split/state")
export const confirmSplitPayment = (method2) => api.post("/frontshop/payment/split/confirm", { method2 })
